import { render, staticRenderFns } from "./StormwatchAdmin.vue?vue&type=template&id=420cd57a&"
import script from "./StormwatchAdmin.vue?vue&type=script&lang=js&"
export * from "./StormwatchAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StormwatchAdmin.vue?vue&type=style&index=0&id=420cd57a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports